import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthenticationNgRxActions } from '@geekbears/gb-ngrx-auth-basic';
import { GBUiMenu } from '@geekbears/ngx-gb-ui-kit';
import { UsersActions } from '@modules/company-manager/users/application/store/users.actions';
import { isAdminSelector } from '@modules/company-manager/users/application/store/users.selectors';
import { AppUser } from '@modules/company-manager/users/domain';
import { CompanyActions } from '@modules/super-admin/company/application/store/company.actions';
import { companyByIdSuccessSelector } from '@modules/super-admin/company/application/store/company.selectors';
import { Company } from '@modules/super-admin/company/domain/entities/company.entity';
import { Store } from '@ngrx/store';
import { Roles } from '@utils/roles';
import { map, Observable, Subject, takeUntil } from 'rxjs';

@Component({
  templateUrl: './admin-main-dashboard.page.html',
  styleUrls: ['./admin-main-dashboard.page.scss'],
})
export class AdminMainDashboardPage
  implements OnInit, AfterViewInit, OnDestroy
{
  /**
   * @destroy$ is used to unsubscribe from all subscriptions
   */
  destroy$: Subject<void> = new Subject();

  itemSelected: string = '';
  menu$!: Observable<GBUiMenu>;
  role!: string;
  currentUser!: AppUser;
  isBlocked: boolean = false;
  isAdmin: boolean | null = false;
  hasDeletionScheduled: string | null = null;
  isExpired: boolean = false;

  constructor(
    private router: Router,
    private store$: Store,
    private cdr: ChangeDetectorRef
  ) {
    this.itemSelected = this.router.url;
    this.currentUser = JSON.parse(localStorage.getItem('s_user') || '{}');

    if (this.currentUser && !this.isSuperAdmin())
      this.fetchCompanyInformation(this.currentUser._companyId!);

    this.getRole();

    this.store$
      .select(companyByIdSuccessSelector)
      .pipe(
        map((company) => {
          if (company && company.length && !this.isSuperAdmin()) {
            const isBypassed = this.currentUser?.isSubscriptionBypassed || this.currentUser?.company?.isSubscriptionBypassed || company[0].isSubscriptionBypassed;
            this.isExpired = isBypassed ? false : (company[0].subscription?.isExpired || false);
            this.hasDeletionScheduled = company[0].deletionScheduledAt;
          }
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  isSuperAdmin() {
    if (
      this.currentUser.roles &&
      this.currentUser.roles.some((item) => item === Roles.superAdmin)
    )
      return true;
    return false;
  }

  fetchCompanyInformation(companyId: string) {
    this.store$.dispatch(
      CompanyActions.getCompanyById({
        companyId: companyId,
      })
    );
  }

  companyManager: any = [
    {
      icon: '',
      name: 'Account Administration',
      route: '/dashboard/users',
      color: 'gray',
      childrens: [
        {
          icon: '',
          name: 'Users',
          route: '/dashboard/users',
          color: 'green',
        },
        {
          icon: '',
          name: 'Clients',
          route: '/dashboard/clients',
          color: 'green',
        },
        {
          icon: '',
          name: 'Request type',
          route: '/dashboard/request-type',
          color: 'green',
        },
        {
          icon: '',
          name: 'Membership',
          route: '/dashboard/membership',
          color: 'green',
        },
      ],
    },
  ];
  regularUser: any = [
    {
      icon: '',
      name: 'Home',
      route: '/dashboard/home',
      color: 'green',
      childrens: [
        {
          icon: '',
          name: 'Request',
          route: '/dashboard/requests',
          color: 'green',
        },
        {
          icon: '',
          name: 'Approve',
          route: '/dashboard/approve',
          color: 'green',
        },
        {
          icon: '',
          name: 'History',
          route: '/dashboard/history',
          color: 'green',
        },
        {
          icon: '',
          name: 'Profile',
          route: '/dashboard/profile',
          color: 'green',
        },
      ],
    },
  ];
  superAdmin: any = [
    {
      icon: '',
      name: 'Home',
      route: '/dashboard/home',
      color: 'gray',
      childrens: [],
    },
    {
      icon: '',
      name: 'Company',
      route: '/dashboard/company',
      color: 'gray',
      childrens: [],
    },
    {
      icon: '',
      name: 'Subscription',
      route: '/dashboard/subscriptions',
      color: 'gray',
      childrens: [],
    },
    {
      icon: '',
      name: 'Change Password',
      route: '/dashboard/change-password',
      color: 'gray',
      childrens: [],
    },
  ];

  ngOnInit(): void {
    this.store$
      .select(isAdminSelector)
      .pipe(
        map((status) => {
          Promise.resolve().then(() => {
            this.isAdmin = status;
          });
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
    this.validateRoute();
    localStorage.removeItem('done');

    if (localStorage.getItem('s_admin') == 'false') {
      this.isAdmin = false;
    } else if (localStorage.getItem('s_admin') == 'true') {
      this.isAdmin = true;
    }

    this.router.events.subscribe((evt: any) => {
      if (evt instanceof NavigationEnd) {
        this.itemSelected = evt.url;
      }
    });
  }
  ngAfterViewInit(): void {}
  /**
   * Regular users
   * @param route is the activated/current route
   * @returns
   */
  regularUserRoutes(route: string) {
    if (
      route.includes('/dashboard/requests') ||
      route.includes('/dashboard/approve') ||
      route.includes('/dashboard/history') ||
      route.includes('/dashboard/home') ||
      route.includes('/dashboard/profile')
    )
      return true;
    else return false;
  }

  /**
   * Super Admin
   * @param route is the activated/current route
   * @returns
   */
  superAdminRoutes(route: string) {
    if (
      route.includes('/dashboard/home') ||
      route.includes('/dashboard/company') ||
      route.includes('/dashboard/subscriptions')
    )
      return true;
    else return false;
  }
  /**
   * Company Manager
   * @param route is the activated/current route
   * @returns
   */
  companyManagerRoutes(route: string) {
    if (
      route.includes('/dashboard/users') ||
      route.includes('/dashboard/clients') ||
      route.includes('/dashboard/membership') ||
      route.includes('/dashboard/request-type')
    )
      return true;
    else return false;
  }

  getRole() {
    if (this.currentUser) {
      if (this.currentUser.roles?.find((role) => role == 'super-admin'))
        this.role = 'super-admin';
      else if (
        this.currentUser.roles?.find(
          (role) => role == Roles.companyAdministrator
        )
      ) {
        this.role = Roles.companyAdministrator;
      } else {
        this.role = 'regular-user';
      }
    }
  }

  logOut() {
    localStorage.removeItem('s_admin');
    localStorage.removeItem('confirmAccountToken');
    localStorage.removeItem('confirmAccountEmail');
    this.store$.dispatch(AuthenticationNgRxActions.logout());
  }
  changeToRegularUser() {
    localStorage.setItem('s_admin', 'false');
    this.store$.dispatch(
      UsersActions.switchToAdmin({
        status: false,
      })
    );

    this.router.navigateByUrl(`/dashboard/home`);
  }

  validateRoute() {
    if (this.regularUserRoutes(this.router.url)) {
      this.store$.dispatch(
        UsersActions.switchToAdmin({
          status: false,
        })
      );
    }
    if (this.companyManagerRoutes(this.router.url)) {
      this.store$.dispatch(
        UsersActions.switchToAdmin({
          status: true,
        })
      );
    }
  }

  navigateToMemberships() {
    this.isAdmin = true;
    localStorage.setItem('s_admin', 'true');
  }
  onMembershipModule() {
    return this.itemSelected.toLocaleLowerCase().includes('membership')
      ? false
      : true;
  }
}
